import styled from 'styled-components';
import is from 'styled-is';
import ShipperOrderCell from './container';

import { groupageBackground } from 'modules/journey/card/styled';

const GroupageTag = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding-right: ${(props) => props.theme.base.gridSizes.XS};
  border-radius: 2px 0 0 2px;
  color: var(--grey700);
  height: ${(props) => props.theme.base.gridSizes.M};

  .ShipperOrderCell-shipperName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1 1 auto;
  }

  ${is('groupage')`
    padding-left: ${(props) => props.theme.base.gridSizes.S};
    background: var(--grey100);
    &:before{
      content: '';
      display: block;
      width:  ${(props) => props.theme.base.gridSizes.XS};
      border-radius: 2px 0 0 2px;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      ${groupageBackground};
    }
  `}
`;

export { GroupageTag };

export default styled(ShipperOrderCell)`
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  overflow: hidden;
  max-width: fit-content;
  position: relative;

  .ShipperOrderCell-clear-button {
    background: var(--grey100);
    border: 0;
    -webkit-appearance: none;
    width: ${(props) => props.theme.base.gridSizes.M};
    height: ${(props) => props.theme.base.gridSizes.M};
    display: flex;
    align-items: center;
    padding: 0;
    justify-content: center;
    border-radius: 2px;
    cursor: pointer;

    &:hover {
      background: var(--grey200);
    }
  }
`;
